import type { BaseModel } from './baseModel';

export const Transmissions = ['AUTOMATICA', 'MANUAL'] as const;
export const CarTypes = ['AUTOMOVIL', 'CAMIONETA', 'CAMION', 'SUV', 'FURGON', 'SEDAN', 'MOTO'] as const;
export const FuelTypes = ['GASOLINA', 'DIESEL', 'ELECTRICO/HIBRIDO', 'ELECTRICO', 'HIBRIDO', 'GAS'] as const;

export interface CarDraft {
  link: string;
  businessUnitId: number;
  referenceId: string;
  brand: string;
  model: string;
  year: number;
  version: string;
  km: number;
  price: number;
  image: string;
  transmission: string;
  carType: string;
  fuelType: string;
  isUsed: true;
  branchOfficeDirection: string;
  color: string;
  category: string;
  monthlyFee?: string | null;
  usageYears?: number | null | undefined;
  businessUnit?: {
    id: number;
    name: string;
  };
  secondaryPrice?: number | null;
  licensePlate?: string | null;
  technicalSheet?: string | null;
  originalImageUrl?: string | null;
  promotions?: string | null;
}

export interface Car extends BaseModel, CarDraft {}

export interface CarComparisonCar {
  id?: number | null | undefined;
  brand?: string | null | undefined;
  model?: string | null | undefined;
  year?: number | null | undefined;
  transmission?: string | null | undefined;
  fuelType?: string | null | undefined;
  price: number;
  km?: number | null | undefined;
  usageYears?: number | null | undefined;
  image?: string | null | undefined;
  link?: string | null | undefined;
  source: 'db' | 'chileautos' | 'mercadolibre';
}
export interface PriceAnalysis {
  car: Car;
  comparison: {
    linearRegressionKm: {
      intercept: number;
      slope: number;
      rSquared: number;
    };
    linearRegressionUsageYears: {
      intercept: number;
      slope: number;
      rSquared: number;
    };
    exponentialRegressionKm: {
      a: number;
      b: number;
      rSquared: number;
    };
    exponentialRegressionUsageYears: {
      a: number;
      b: number;
      rSquared: number;
    };
    multiLinearRegression: {
      intercept: number;
      slopeKm: number;
      slopeUsageYears: number;
      rSquared: number;
    };
    multiExponentialRegression: {
      a: number;
      bKm: number;
      bUsageYears: number;
      rSquared: number;
    };
    averagePrice: number;
    standardDeviation: number;
    standardDeviationsOfCar: number;
    priceDeviation: number;
    predictedPrice: number;
    standardDeviationOfResiduals: number;
    source: 'db' | 'chileautos' | 'general' | 'same-transmission' | 'mercadolibre' | 'most-similar';
    cars: CarComparisonCar[];
  }[];
}

export interface ModelStatistic {
  modelKey: string;
  modelName: string;
  totalCars: number;
  averageTimeToSell: number;
  percentile10: number;
  percentile90: number;
  minTimeToSell: number;
  maxTimeToSell: number;
}

export interface TimeToSellData {
  totalSoldCars: number;
  averageTimeToSell: number;
  buckets: {
    labels: string[];
    values: number[];
  };
  modelStatistics: ModelStatistic[];
  dailyBuckets: Record<number, number>;
}
